import {DealCategory, DealsTag} from "@irati/types"
import {ERROR_CATEGORY, ALL_CATEGORY} from "../../components/DealList/BadCategoryOrTag"

export function getSelectedCategory(categories: DealCategory[], categoryUrl?: string): DealCategory {
  if (!categoryUrl) {
    return ALL_CATEGORY
  }

  const selected = categories.filter((item) => item.url === categoryUrl)[0]

  return selected || ERROR_CATEGORY
}

export function getSelectedTags(category: DealCategory, tagsFromQuery?: string[]): DealsTag[] {
  if (!category) {
    return []
  }
  const {tags} = category

  if (!tagsFromQuery) {
    return tags
  }

  return tags.filter((tag) => tagsFromQuery.indexOf(tag.url) > -1)
}
